export const FEATURE_FLAGS = {
  SAMPLE_FEATURE: 'sample-feature',
  ENABLE_APOLLO_TAXONOMY_FEATURE: 'enable-apollo-taxonomy-feature',
  ENABLE_TAXONOMY: 'enable-taxonomy',
  ENABLE_APOLLO_AI_FEATURE: 'enable-apollo-ai-feature',
  GENAI_UPDATE_MANAGER_COMMENTS: 'genai-update-manager-comments',
  ENABLE_APOLLO_DOCUMENT_VALIDATION: 'enable-apollo-document-validation',
};
